var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vector2i, E } from "js-vextensions";
import React from "react";
import { Column, Pre } from "react-vcomponents";
import { BaseComponent, ClassBasedStyles } from "react-vextensions";
import { VMenuItem, VMenuStub } from "react-vmenu";
import { DeleteBookEvent } from "Server/Commands/DeleteBookEvent";
import { UpdateBookEvent } from "Server/Commands/UpdateBookEvent";
import { GetSeed } from "Store/firebase/seeds";
import { ShowMessageBox } from "react-vmessagebox";
import { GetScreenRect, MakeDraggable, Observer } from "vwebapp-framework";
import { GetEventMainCharacterIDs, GetEventMainCharacters } from "Store/firebase/events/$event";
import { GetEventWeekAndDay } from "Store/firebase/events";
import { styles } from "Utils/UI/GlobalStyles";
import { DraggableInfo } from "Utils/UI/DNDStructures";
import { runInAction } from "mobx";
import { store } from "Store";
import classnames from "classnames";
import { SetBookEventIndex } from "../../../Server/Commands/SetBookEventIndex";
import { AddEventBar } from "../Events";
let EventRow = class EventRow extends BaseComponent {
    constructor() {
        super(...arguments);
        this.OnMouseMove = (e) => {
            const orderedColumn = this.props.orderIndex != null;
            if (!orderedColumn || this.actualButton == null)
                return;
            // let rect = GetScreenRect(this.innerRoot.DOM as any);
            const rect = GetScreenRect(this.actualButton);
            this.SetState({ addEventBarPosition: new Vector2i(rect.Right, rect.Center.y) });
        };
        this.OnMouseLeave = (e) => {
            this.CloseAddEventBar();
        };
        this.CloseAddEventBar = () => {
            this.SetState({ addEventBarPosition: null });
        };
    }
    render() {
        const { event, index, previousEvent, selected, character, orderIndex, style, dragInfo, ...rest } = this.props;
        const { addEventBarPosition } = this.state;
        const { week, day } = GetEventWeekAndDay(event, character.book, character._key);
        const { week: weekOfPrev, day: dayOfPrev } = previousEvent ? GetEventWeekAndDay(previousEvent, character.book, character._key) : { week: null, day: null };
        const orderedColumn = orderIndex != null;
        let text = event.text || (GetSeed(event.seed) || {}).text;
        if (event.placeholderCount != null) {
            text = `Placeholder (${event.placeholderCount})`;
        }
        const mainCharacterIDs = GetEventMainCharacterIDs(event);
        if (mainCharacterIDs.length && !mainCharacterIDs.Contains(character._key)) {
            const mainCharacters = GetEventMainCharacters(event);
            text = `${mainCharacters.length ? mainCharacters.First().name : `[${mainCharacterIDs.First()}]`}: ${text}`;
        }
        const wordsInSteps = event.steps == null || event.steps.length <= 0 ? 0 : event.steps.map(step => {
            const actions = step.actions.VValues();
            return actions.map(a => (a.trim().length == 0 ? 0 : a.split(" ").length)).Sum();
        }).Sum();
        const wordsInFullText = event.fullText && event.fullText.trim().length ? event.fullText.SplitByAny(" ", "\n").length : 0;
        const asDragPreview = dragInfo && dragInfo.snapshot.isDragging;
        const finalStyle = E({
            display: "inline-flex", backgroundColor: "rgba(90,100,110,.6)", borderRadius: 5, border: "1px solid rgba(210,210,230,.12)",
            color: "rgb(170,170,170)", fontSize: 14, cursor: "pointer", padding: "5px 10px", width: "100%",
            ":hover": { backgroundColor: "rgba(90,100,110,.8)" },
        }, selected && { backgroundColor: "rgba(90,100,110,.8)" }, event.placeholderCount && { backgroundColor: placeholderCountColorMap[event.placeholderCount], fontSize: 10, padding: "1px 15px" }, asDragPreview && { opacity: .3 });
        return (React.createElement("div", Object.assign({}, (dragInfo && dragInfo.provided.draggableProps), (dragInfo && dragInfo.provided.dragHandleProps)),
            React.createElement(Column, { ref: c => this.innerRoot = c, style: { position: "relative" }, onContextMenu: e => e.preventDefault(), onMouseMove: this.OnMouseMove, onMouseLeave: this.OnMouseLeave },
                orderedColumn && week != null && week != weekOfPrev &&
                    React.createElement(Pre, { style: E({ marginTop: orderIndex == 0 ? 5 : 50, marginBottom: 5, fontSize: 21, textAlign: "center", color: week >= weekOfPrev ? "rgba(255, 255, 255, 0.7)" : "red" }, asDragPreview && { opacity: 0 }) },
                        "Week ",
                        week),
                orderedColumn && ((week != null && week != weekOfPrev) || (day != null && day != dayOfPrev)) &&
                    React.createElement(Pre, { style: E({ marginTop: 5 /* event.week ? 5 : 25 */, marginBottom: 5, fontSize: 18, textAlign: "center", color: weekOfPrev == null || week > weekOfPrev || (week == weekOfPrev && day >= dayOfPrev) ? "rgba(255, 255, 255, 0.7)" : "red" }, asDragPreview && { opacity: 0 }) },
                        "Day ",
                        day || 1),
                React.createElement("div", { ref: c => this.actualButton = c, className: classnames(ClassBasedStyles(finalStyle), "focusTarget"), style: finalStyle, onClick: e => {
                        const buttonRect = GetScreenRect(e.target);
                        runInAction("EventRow.onClick", () => {
                            store.main.write.selectedEvent = event._key;
                            store.main.write.selectedEvent_character = character._key;
                            store.main.write.selectedEvent_position = new Vector2i(buttonRect.Right, buttonRect.Top);
                        });
                    } },
                    text,
                    (wordsInSteps != 0 || wordsInFullText) != 0 &&
                        React.createElement("div", { style: { marginLeft: "auto", color: "rgba(0,255,0,.7)" } },
                            wordsInSteps,
                            "/",
                            wordsInFullText)),
                React.createElement(VMenuStub, { preOpen: e => e.noVMenu != true },
                    React.createElement(VMenuItem, { text: "Set placeholder count: none", style: styles.vMenuItem, onClick: e => new UpdateBookEvent({ id: event._key, updates: { placeholderCount: null } }).Run() }),
                    React.createElement(VMenuItem, { text: "Set placeholder count: 1", style: styles.vMenuItem, onClick: e => new UpdateBookEvent({ id: event._key, updates: { placeholderCount: 1 } }).Run() }),
                    React.createElement(VMenuItem, { text: "Set placeholder count: 3", style: styles.vMenuItem, onClick: e => new UpdateBookEvent({ id: event._key, updates: { placeholderCount: 3 } }).Run() }),
                    React.createElement(VMenuItem, { text: "Set placeholder count: 5", style: styles.vMenuItem, onClick: e => new UpdateBookEvent({ id: event._key, updates: { placeholderCount: 5 } }).Run() }),
                    React.createElement(VMenuItem, { text: "Set placeholder count: 10", style: styles.vMenuItem, onClick: e => new UpdateBookEvent({ id: event._key, updates: { placeholderCount: 10 } }).Run() }),
                    orderedColumn
                        && React.createElement(VMenuItem, { text: "Move to unordered", style: styles.vMenuItem, onClick: e => new SetBookEventIndex({ characterID: character._key, eventID: event._key, index: null }).Run() }),
                    React.createElement(VMenuItem, { text: "Delete" // enabled={ForDelete_GetError(userID, map, node) == null} title={ForDelete_GetError(userID, map, node)}
                        , style: styles.vMenuItem, onClick: e => {
                            if (e.button != 0)
                                return;
                            ShowMessageBox({
                                title: `Delete "${text}"`, cancelButton: true,
                                message: `Delete the event "${text}"?`,
                                onOK: () => {
                                    new DeleteBookEvent({ id: event._key }).Run();
                                },
                            });
                        } })),
                addEventBarPosition &&
                    React.createElement("div", { style: { position: "fixed", zIndex: 12, left: addEventBarPosition.x, top: addEventBarPosition.y, display: "flex", alignItems: "center", height: 0 } },
                        React.createElement("div", { style: { position: "relative" } },
                            React.createElement("div", { id: "scrollBarBlocker", style: { position: "absolute", right: "100%", width: 8, height: "100%" } }),
                            React.createElement(Column, { style: { padding: 5, background: "rgba(0,0,0,.7)", borderRadius: 5, boxShadow: "rgba(0,0,0,1) 0px 0px 2px", width: 200 } },
                                React.createElement(AddEventBar, { bookID: event.book, character: character, insertIndex: orderIndex, style: { flex: 1 }, onAction: this.CloseAddEventBar }),
                                React.createElement(AddEventBar, { bookID: event.book, character: character, insertIndex: orderIndex + 1, style: { flex: 1 }, onAction: this.CloseAddEventBar })))))));
    }
};
EventRow = __decorate([
    MakeDraggable((props) => {
        const { event, index } = props;
        return {
            type: "BookEvent",
            draggableInfo: new DraggableInfo({ eventID: event._key }),
            index,
        };
    }),
    Observer
], EventRow);
export { EventRow };
const placeholderCountColorMap = {
    1: "rgba(100, 100, 70, 0.5)",
    3: "rgba(150, 100, 70, 0.5)",
    5: "rgba(150, 50, 50, 0.5)",
    10: "rgba(255, 0, 0, 0.3)",
};
